<script>
import DatePicker from 'vue-datepicker-next';
export default {
  components: { DatePicker },
  props: {
    modelValue: {
      type: Array,
      default: undefined,
    },
    confirmText: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['change', 'update:modelValue'],
  computed: {
    currentValue() {
      return this.modelValue === undefined ? this.value : this.modelValue;
    },
  },
  methods: {
    handleChange(value) {
      this.$emit('update:modelValue', value);
      this.$emit('change', value);
    },
  },
};
</script>

<template>
  <div class="date-picker">
    <DatePicker
      range
      confirm
      :clearable="false"
      :editable="false"
      :confirm-text="confirmText"
      :placeholder="placeholder"
      :value="currentValue"
      @change="handleChange"
    />
  </div>
</template>
